const AppConstants = {
  ERROR_OCCUR: "Có lỗi xảy ra vui lòng thử lại sau",
  NULL: "Chưa có dữ liệu",
  FILE_LARGE: "File quá lớn, vui lòng chọn file nhỏ hơn 5MB",
};

export default AppConstants;
